import React from 'react';
import {
    Button, ButtonGroup,
    Card,
    CardBody,
    CardHeader,
    Col,
    DropdownItem,
    DropdownMenu,
    DropdownToggle,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Row,
    Table,
    UncontrolledButtonDropdown,
} from 'reactstrap';
import {parseDate, sortirMap} from '../../utils/Utilities';
import {DD_MM_YYYY_HH_MM_SS} from '../../utils/Global';
import {RELEASE_VERIFICATION_STATUS_COLOR} from 'enqc-utilities/src/utils/Global'
import queryString from 'query-string';
// import label from '../../message/Label'
import label from 'enqc-utilities/src/label/Label'
import Endpoint from "enqc-utilities/src/api/Endpoint";
import PropTypes from "prop-types";
import BaseComponent from "../BaseComponent";
import ModalPagination from "../ModalPagination";
import {delegateObjectsForSelection} from "enqc-utilities/src/utils/Utilities";
import DropdownInput from "../form/DropdownInput";


export default class ReleaseVerificationHistoryModal extends BaseComponent{

    constructor(props) {
        super(props);
        this.state ={
            ascending:false,
            releaseVerification:this.props.releaseVerification,
            sortir:'ah.updated',
            page :queryString.parse(this.props.query).page?queryString.parse(this.props.query).page:1,
            key:queryString.parse(this.props.query).tab?queryString.parse(this.props.query).tab:label.All,
            totalPage:0,
            totalElement:0,
            pageElement:0,
            createdStartDate:null,
            createdEndDate:null,
            releaseVerificationHistories:[],
            releaseVerificationStatus:null,
            releaseVerificationStatusId:null,
            search:queryString.parse(this.props.query).search?queryString.parse(this.props.query).search:"",
            inputSearch : "",
        }
    }


    componentWillReceiveProps(props, nextContext) {
        if(props!=this.props && props.showing && props.releaseVerification && props.releaseVerification.id){
            let page = queryString.parse(props.query).page?queryString.parse(props.query).page:1
            let key = queryString.parse(props.query).tab?queryString.parse(props.query).tab:label.All
            let search = queryString.parse(props.query).search?queryString.parse(props.query).search:""
            let releaseVerificationStatusId = null
            if(key===label.All){
                releaseVerificationStatusId = null
            }else{
                releaseVerificationStatusId = key
            }
            this.setState({
                page:page,
                key:key,
                search:search,
                releaseVerificationStatusId:releaseVerificationStatusId,
                releaseVerification:props.releaseVerification,
            }, () => {
                this.fetchAll(this.state.ascending, this.state.sortir, this.state.search, true)
            })
        }
    }

    fetchAll = (ascending, sortir, search, progressing, excelMode) =>{
        let params = {
            releaseVerificationStatusId:this.state.releaseVerificationStatusId,
            ascending:ascending,
            sortir:sortir,
            search:search,
            page:this.state.page-1,
            reference:this.state.releaseVerification.reference,
            createdStartDate:this.state.createdStartDate,
            createdEndDate:this.state.createdEndDate,
            excelMode:excelMode

        }
        if(excelMode){
            this.asyncDownloadGet(Endpoint.API.RELEASE_VERIFICATION_HISTORIES, {params:params}, null,true);
            return
        }
        this.get(Endpoint.API.RELEASE_VERIFICATION_HISTORIES, {params:params}, null, res =>{
            if(res.code === 200){
                let releaseVerificationHistories = res.data;
                this.setState({
                    releaseVerificationHistories : releaseVerificationHistories,
                    totalPage: res.totalPage,
                    totalElement: res.totalElement,
                    pageElement: res.pageElement,
                })
            }
        }, progressing, true);
    }

    renderReleaseVerifications = (ascending, sortir, progressing) => (
        this.setState({
            ascending:ascending,
            sortir:sortir,
        }, () => {
            this.fetchAll(ascending, sortir, this.state.search, progressing)
        })
    )




    render() {

        return (
            <>
                {super.render()}
                <Modal
                    autoFocus={false}
                    style={{minWidth:'90%'}}
                    size="xl"
                    centered={true}
                    isOpen={this.props.showing}
                    backdrop={true}>
                    {super.render()}
                    <ModalHeader>
                        {label.VerificationHistory}
                    </ModalHeader>
                    <ModalBody>
                        {this.renderReleaseVerificationHistories()}
                    </ModalBody>
                    <ModalFooter>
                        <Button
                            color="secondary"
                            onClick={e=>{
                                e.preventDefault()
                                this.props.onClose()
                            }}>
                            {label.Close}
                        </Button>
                    </ModalFooter>
                </Modal>

            </>
        )
    }

    renderReleaseVerificationHistories = () =>{
        let {ascending, sortir} = this.state
        let orderOptions = delegateObjectsForSelection(
            {name:label.Reference, field:'ah.reference'},
            {name:label.Performer, field:'u.firstname'},
            {name:label.Created, field:'u.created'}
        )
        let ascendingOptions = delegateObjectsForSelection( {name:label.Descending, field:false}, {name:label.Ascending, field:true})
        return (
            <Row key={2}>
                <Col>
                    <Card>
                        <CardHeader>
                            <strong>{label.VerificationHistory}</strong>
                            <br/><br/>
                            <Row>
                                <Col>
                                    <ButtonGroup className="d-flex w-100">
                                        <DropdownInput
                                            title={label.SortBy}
                                            options={orderOptions}
                                            onSelect={(item) => {
                                                this.renderReleaseVerifications(ascending, item.field, true)
                                            }}
                                            onReset={() => {
                                                this.renderReleaseVerifications(ascending, "ah.created", true)
                                            }}/>
                                        &nbsp;&nbsp;&nbsp;
                                        <DropdownInput
                                            options={ascendingOptions}
                                            onSelect={(item) => {
                                                this.renderReleaseVerifications(item.field, sortir, true)
                                            }}
                                            onReset={() => {
                                                this.renderReleaseVerifications(true, sortir, true)
                                            }}/>
                                    </ButtonGroup>
                                </Col>
                            </Row>
                        </CardHeader>
                        <CardBody>
                            {this.renderReleaseVerificationHistoriesTable()}
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        )
    }


    renderReleaseVerificationHistoriesTable = () =>{
        let {page, totalElement, totalPage, ascending, sortir} = this.state
        return (
            <Card>
                <CardBody>
                    <Table responsive hover>
                        <thead>
                        <tr>
                            <th>#</th>
                            <th>{label.ReferenceCode}</th>
                            <th>{label.SystemType}</th>
                            <th>{label.Performer}</th>
                            <th style={{width:'15%'}}>{label.Status}</th>
                            <th>{label.Created}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {
                            this.state.releaseVerificationHistories.map((item, index)=>(
                                <tr key={item.id}>
                                    <th scope="row">{((this.state.page-1)* this.state.pageElement)+(++index)}</th>
                                    <td><span>{item.releaseVerification.reference}</span></td>
                                    <td>{item.attachedModel.systemType}</td>
                                    <td>
                                        {
                                            item.user&&(<a href={'/userDetail?id='+item.user.id}>{item.user.fullname}/{item.user.manufacturingSite.name}</a>)
                                        }
                                    </td>
                                    <td>
                                        <span
                                            style={
                                                {
                                                    color:RELEASE_VERIFICATION_STATUS_COLOR[item.releaseVerificationStatus.name],
                                                    paddingLeft:'8px', paddingRight:'8px', paddingTop:'4px', paddingBottom:'4px',
                                                    fontWeight:'bold', borderRadius:'8px'
                                                }
                                            }>
                                            {label(item.releaseVerificationStatus.name)}
                                        </span>
                                    </td>
                                    <td>{parseDate(item.created, DD_MM_YYYY_HH_MM_SS)}</td>
                                </tr>
                            ))
                        }
                        </tbody>
                    </Table>
                </CardBody>
                <ModalPagination {...this.props} currentPage={page} pageCount={totalPage} onSelect={(page)=>{
                    this.setState({
                        page:page
                    }, () => {
                        this.renderReleaseVerifications(ascending, sortir, true)
                    })
                }}/>
            </Card>
        )
    }


}

ReleaseVerificationHistoryModal.propTypes = {
    showing:PropTypes.bool.isRequired,
    onClose:PropTypes.func.isRequired,
    releaseVerification:PropTypes.object.isRequired
}
